import { getRandomNumber, useAppTranslation } from "@/utils";
import { Close, InfoCircleFilled } from "@payping/icons";
import { URLS } from "@payping/utilities-shared/consts";
import { Alert, Button, Card, Drawer, Flex, Grid, Typography } from "@payping/web-components";
import { clsx } from "clsx";
import { FC, useState } from "react";

const GetOrderUploadVideoAndSignaturePageAccessGuide: FC = () => {
  const { t } = useAppTranslation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const { lg } = Grid.useBreakpoint();

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const allSentence: string[] = t("videoAuthenticationSentences", { returnObjects: true }) as string[];

  const helpSteps: string[] = lg
    ? (t("pay.getOrder.steps.uploadVideoAndSignature.accessGuide.desktop.steps", { returnObjects: true }) as string[])
    : (t("pay.getOrder.steps.uploadVideoAndSignature.accessGuide.mobile.steps", { returnObjects: true }) as string[]);

  return (
    <>
      <Flex vertical className="tw:relative tw:h-full" gap={"middle"}>
        <Flex className="tw:relative tw:mt-8! tw:w-full" vertical gap={"middle"}>
          <Flex className={clsx(["tw:absolute -tw:top-8 tw:z-10 tw:w-full tw:px-4!"])}>
            <Card className="tw:w-full tw:text-center" size="small">
              <Typography.Title level={5} className="tw:m-0!">
                {allSentence[getRandomNumber(allSentence.length)]}
              </Typography.Title>
            </Card>
          </Flex>
          <img
            className="tw:min-h-75 tw:w-full"
            src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-denied.png`}
            alt={"user-camera-access-denied"}
          />
          <Flex
            className={clsx({
              "tw:absolute -tw:bottom-8 tw:left-0 tw:w-full tw:px-4!": lg,
              "tw:w-full": !lg,
            })}
          >
            <Alert
              className="tw:w-full"
              title={t("pay.getOrder.steps.uploadVideoAndSignature.accessWarning")}
              description={
                <Flex vertical align="start">
                  <Typography.Text>
                    {t("pay.getOrder.steps.uploadVideoAndSignature.accessDeniedAlert.content")}
                  </Typography.Text>
                  <Button onClick={handleOpenDrawer} type="link">
                    {t("pay.getOrder.steps.uploadVideoAndSignature.createAccessGuide")}
                  </Button>
                </Flex>
              }
              type="error"
              showIcon
              icon={<InfoCircleFilled width={24} height={24} />}
            />
          </Flex>
        </Flex>
      </Flex>
      <Drawer
        open={openDrawer}
        onClose={handleCloseDrawer}
        size={"100%"}
        closeIcon={false}
        title={t("pay.getOrder.steps.uploadVideoAndSignature.accessWarning")}
        placement="bottom"
        extra={
          <Button
            type={"text"}
            icon={<Close width={14} height={14} />}
            onClick={() => {
              handleCloseDrawer();
            }}
          />
        }
      >
        <Flex className="tw:w-full" vertical gap={"middle"}>
          {lg ? (
            <>
              <Typography.Text>
                {t("pay.getOrder.steps.uploadVideoAndSignature.accessGuide.desktop.title")}
              </Typography.Text>
              {helpSteps.map((item, index) => (
                <Typography.Text key={index}>{`${index + 1}- ${item}`}</Typography.Text>
              ))}
              <img
                className="tw:w-75"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-desktop-1.jpeg`}
                alt={"user-camera-access-guide-desktop-1"}
              />
            </>
          ) : (
            <>
              <Typography.Text>
                {t("pay.getOrder.steps.uploadVideoAndSignature.accessGuide.mobile.title")}
              </Typography.Text>
              <Typography.Text>{`1- ${helpSteps[0]}`}</Typography.Text>
              <img
                className="tw:w-full tw:max-w-100"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-mobile-1.jpeg`}
                alt={"user-camera-access-guide-mobile-1"}
              />
              <Typography.Text>{`2- ${helpSteps[1]}`}</Typography.Text>
              <img
                className="tw:w-full tw:max-w-100"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-mobile-2.png`}
                alt={"user-camera-access-guide-mobile-2"}
              />
              <img
                className="tw:w-full tw:max-w-100"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-mobile-3.png`}
                alt={"user-camera-access-guide-mobile-3"}
              />
              <Typography.Text>{`3- ${helpSteps[2]}`}</Typography.Text>
              <img
                className="tw:w-full tw:max-w-100"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-mobile-3.png`}
                alt={"user-camera-access-guide-mobile-3"}
              />
              <img
                className="tw:w-full tw:max-w-100"
                src={`${URLS.STORAGE_URL}/bnpl-consumer/user-camera-access-guide-mobile-4.png`}
                alt={"user-camera-access-guide-mobile-4"}
              />
              <Typography.Text>{`4- ${helpSteps[3]}`}</Typography.Text>
            </>
          )}
        </Flex>
      </Drawer>
    </>
  );
};

export default GetOrderUploadVideoAndSignaturePageAccessGuide;
